import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SweetAlert from "sweetalert-react";
import * as Utils from "../../utils/utils";
import * as Swal from "../../utils/swalHelpers";
import * as LocalStorage from "../../utils/localStorageHelper";
import ChevronIcon from "../../assets/images/icons/right-thin-chevron.svg";
import ProductCard from "../../components/commons/cards/ProductCard";
import * as ProductsActions from "../../actions/productsActions";
import * as UserActions from "../../actions/userActions";
import Loader from "../../components/commons/loader/loader";
import withSizes from "react-sizes";
import menuDepKeys from "../../utils/menuHelper";
import QueryString from "query-string";

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlert: false,
      swalParams: {
        title: ""
      },
      openDepartmentMenu: false,
      currentDepartment: undefined,
      searchTerm: ""
    };

    this.doAgeValidation = this.doAgeValidation.bind(this);
    this.renderProducts = this.renderProducts.bind(this);
    this.exploreProduct = this.exploreProduct.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.handleError = this.handleError.bind(this);
    this.onSelectFeaturedProduct = this.onSelectFeaturedProduct.bind(this);
    this._onCancel = this._onCancel.bind(this);
    this.handleDepartmentClick = this.handleDepartmentClick.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
  }
  componentDidMount() {
    this.doAgeValidation();
    let params = {
      limit: 3,
      skip: 0,
      from: "home"
    };
    const callback = response => {
      if (response.status) {
        // id is required
        const impressions = response.data.map(p => ({
          id: p._id,
          name: p.Description,
          ...p
        }));
        window.dataLayer.push({ event: "home", ecommerce: { impressions } });
      } else {
        this.handleError(response);
      }
    };

    this.props.dispatch(
      ProductsActions.getNewArrivalProducts(params, callback)
    );
    this.props.dispatch(ProductsActions.getSpecialProducts(params, callback));
    this.props.dispatch(
      ProductsActions.fetchFeaturedProducts("WINES", callback)
    );
    this.props.dispatch(
      ProductsActions.fetchFeaturedProducts("BEER", callback)
    );
    this.props.dispatch(
      ProductsActions.fetchFeaturedProducts("LIQUOR", callback)
    );
    this.props.dispatch(UserActions.promoImage());
    
  }
  

  componentWillReceiveProps(newProps, oldProps) {
    console.log(newProps, oldProps);
    if (newProps.location) {
      const location = newProps.location;
      const { department } = QueryString.parse(location.search);
      console.log(department);
      if (department) {
        this.setState({
          openDepartmentMenu: true,
          currentDepartment: decodeURIComponent(department)
        });
      } else {
        this.setState({
          openDepartmentMenu: false,
          currentDepartment: undefined
        });
      }
    }
  }

  exploreProduct(product) {
    console.log("PRODUCT_SELECTED_ID: ", product._id);
    this.props.history.push(`/products/${product._id}`);
  }
  
  renderProducts(type) {
    
    let category;
    if (type == "newArrivals") {
      category = Utils.toJS(this.props.newArrivals);
    } else {
      category = Utils.toJS(this.props.specials);
    }
    if (category) {
      return (
        <div className="row">
          {category.map(product => {
            return (
              <div
                className="col-md-4 col-sm-4 product-card-container"
                key={product._id}
              >
                <ProductCard
                  data={product}
                  onSelectProduct={() => this.exploreProduct(product)}
                  onAddToCart={() => this.addToCart(product)}
                  label={type === "newArrivals" ? "New" : "Deal"}
                  noOutOfStock={true}
                />
              </div>
            );
          })}
        </div>
      );
    } else {
      return "Loading";
    }
  }

  handleSearchChange(event) {
    this.setState({ searchTerm: event.target.value });
  }

  handleSearchSubmit(event) {
    event.preventDefault();
    const { searchTerm } = this.state;
    const query = searchTerm ? `?q=${encodeURIComponent(searchTerm)}` : "";
    this.props.history.push(`/search${query}`);
  }

  renderCategoryPills() {
    let { departments } = this.props;
    departments = departments
      ? [...departments]
          .filter((department) => menuDepKeys[department.dep])
          .sort((a, b) => a.priority - b.priority)
      : [];

    return (
      <div className="category-pills">
        {departments.map(department => {
          const pillClass = `category-pill dep-${department.dep
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')}`;

          return (
            <Link
              key={department.dep}
              className={pillClass}
              data-department={department.dep}
              to={`/products?department=${encodeURIComponent(department.dep)}`}
            >
              {menuDepKeys[department.dep] && (
                <span className="pill-icon">
                  <img src={menuDepKeys[department.dep].icon} alt="" />
                </span>
              )}
              {department.dep}
            </Link>
          );
        })}
      </div>
    );
  }

  handleDepartmentClick(department) {
    this.props.history.push(
      `/?department=${encodeURIComponent(department.dep)}`
    );
    window.scrollTo(0, 0);
  }

  renderMobileDepartments() {
    let { departments, promoImage } = this.props;
    departments = departments.sort((a, b) => {
      return a.priority > b.priority;
    });
    console.log(departments);
    return (
      <div className="main-nav-mobile">
        <div className="d-flex text-center p-3 border-bottom-gray text-uppercase"><div className="col"><Link to="/products/newarrivals">New Arrivals</Link></div><div className="col border-left-gray"><Link to="/products/specials">Specials</Link></div></div>
        <ul className="list">
          {departments.map(department => {
            return menuDepKeys[department.dep] ? (
              <li key={department.dep}>
                <a onClick={() => this.handleDepartmentClick(department)}>
                  <div className="thumb">
                    <img src={menuDepKeys[department.dep].icon} alt="" />
                  </div>
                  <div className="content">
                    <h2>{department.dep}</h2>
                    <p>{menuDepKeys[department.dep].label}</p>
                  </div>
                  <div className="thumb right">
                    <img src={ChevronIcon} alt="" />
                  </div>
                </a>
              </li>
            ) : null;
          })}
        </ul>
        {promoImage && promoImage.PromoMobileImage && (
          <div>
            {promoImage && promoImage.ProductIdMobile.length > 0 ? (
            <div className="col-md-12 col-lg-7 featured-image-container banner-container">
            <img src={promoImage.PromoMobileImage[0]} className="image"  alt="Promotional Items banner"/>
            <div class="middle">
            <div className="list-group">
            <span className='promotional-item-text pb-2'>PROMOTIONAL PRODUCTS :</span>
            <ul>
            {
              this.props.promoImage.ProductIdMobile.map((productid, i) => {
              let currentUrl = `products/${productid._id}`;                 
              return (<li key={i} className="promotional-item-text pl-2"><Link to={currentUrl} >{productid.Description}</Link></li>) 
            })}</ul>
            </div>
            </div>
            </div>
            ) : (
              null
            )}
          </div>
        )}
      </div>
    );
  }

  renderMobileCategories() {
    let { currentDepartment } = this.state;
    const { departments } = this.props;
    currentDepartment = departments.find(department => {
      return department.dep == currentDepartment;
    });

    return (
      <div className="main-nav-mobile">
        <ul className="list">
          {currentDepartment && (
            <li>
              <Link
                className="category"
                to={`/products?department=${encodeURIComponent(
                  currentDepartment.dep
                )}`}
              >
                <div className="content">
                  <h2 className="category-heading">
                    ALL {currentDepartment.dep}
                  </h2>
                </div>
                <div className="thumb right">
                  <img src={ChevronIcon} alt="" />
                </div>
              </Link>
            </li>
          )}

          {currentDepartment &&
            currentDepartment.cat.map(category => {
              return (
                <li key={category}>
                  <Link
                    className="category"
                    to={`/products?category=${encodeURIComponent(category)}`}
                  >
                    <div className="content">
                      <h2 className="category-heading">{category}</h2>
                    </div>
                    <div className="thumb right">
                      <img src={ChevronIcon} alt="" />
                    </div>
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }

  render() {
    console.log("HOME_PAGE_PROPS", this.props);
    const { loading, isMobile, promoImage, departments } = this.props;
    const { showAlert, swalParams, openDepartmentMenu } = this.state;
    let featured_WINES = Utils.toJS(this.props.featured_WINES);
    let featured_LIQUOR = Utils.toJS(this.props.featured_LIQUOR);
    let featured_BEER = Utils.toJS(this.props.featured_BEER);
    const featuredProducts = [
      ...(featured_WINES || []),
      ...(featured_LIQUOR || []),
      ...(featured_BEER || [])
    ].slice(0, 4);

    const badgeLabels = ["Featured", "Best Seller", "Premium", "Popular"];
    const statsItems = [
      { label: "30-Min Delivery", icon: "clock" },
      { label: "5000+ Products", icon: "layers" },
      { label: "40+ Years", icon: "badge" }
    ];
    const mobileDepartments = departments
      ? [...departments]
          .filter((department) => menuDepKeys[department.dep])
          .sort((a, b) => a.priority - b.priority)
      : [];
    const benefits = [
      { title: "30-Min Delivery", subtitle: "Lightning-fast to your door", icon: "⚡" },
      { title: "40+ Years Trusted", subtitle: "Premium selection since 1983", icon: "⭐" },
      { title: "Quality Guaranteed", subtitle: "Hand-picked and verified", icon: "✅" }
    ];

    const Icon = ({ type }) => {
      if (type === "clock") {
        return (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="#0aa6d5" strokeWidth="1.6" />
            <path d="M12 7v5l3 2" stroke="#0aa6d5" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        );
      }
      if (type === "layers") {
        return (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M12 4l8 4-8 4-8-4 8-4z" stroke="#0aa6d5" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M4 12l8 4 8-4" stroke="#0aa6d5" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M4 16l8 4 8-4" stroke="#0aa6d5" strokeWidth="1.6" strokeLinejoin="round" />
          </svg>
        );
      }
      if (type === "badge") {
        return (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="10" r="5.5" stroke="#0aa6d5" strokeWidth="1.6" />
            <path d="M9.2 14.5l-1.2 6 4-2 4 2-1.2-6" stroke="#0aa6d5" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );
      }
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <rect x="4" y="7" width="16" height="11" rx="2" stroke="#0aa6d5" strokeWidth="1.6" />
          <path d="M8 7V5h8v2" stroke="#0aa6d5" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      );
    };

    const heroSection = (
      <section className="hero-section">
        <div className="hero-surface">
          <div className="hero-inner">
            <h1 className="hero-title">
              <span className="hero-line">Premium Wine, Spirits &amp; Beer</span>
              <span className="hero-accent">Delivered Fast in DTLA</span>
            </h1>
            <p className="hero-subtitle">Downtown LA's trusted liquor store for over 50 years.</p>
            <form className="hero-search" onSubmit={this.handleSearchSubmit}>
              <span className="search-icon">
                <i className="fa fa-search" aria-hidden="true" />
              </span>
              <input
                type="text"
                placeholder="Search wines, spirits, beers..."
                value={this.state.searchTerm}
                onChange={this.handleSearchChange}
                aria-label="Search for wine, spirits, beer, or brands"
              />
              <button type="submit">
                Search
              </button>
            </form>
            <div className="hero-cta-wrapper">
              <Link to="/products?department=SPARKLING%20WINE"  className="hero-cta">
                Shop Now
                <i className="fa fa-chevron-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    );

    const mobileContent = (
      <div className="home-mobile-shell">
        <form className="mobile-search" onSubmit={this.handleSearchSubmit}>
          <span className="search-icon">
            <i className="fa fa-search" aria-hidden="true" />
          </span>
          <input
            type="text"
            placeholder="Search wines, spirits, beers..."
            value={this.state.searchTerm}
            onChange={this.handleSearchChange}
            aria-label="Search for wine, spirits, beer, or brands"
          />
          <button type="submit" aria-label="Search">
            <i className="fa fa-arrow-right" aria-hidden="true" />
          </button>
        </form>

        <section className="mobile-hero">
          <h1 className="mobile-hero-title">Premium Wine, Spirits &amp; Beer</h1>
          <div className="mobile-hero-accent">Delivered Fast in DTLA</div>
          <p className="mobile-hero-subtitle">
            Downtown LA's trusted liquor store for over 50 years.
          </p>
          <Link to="/products?department=SPARKLING%20WINE" className="mobile-cta">
            Shop Now <span className="arrow">→</span>
          </Link>

          <div className="mobile-stats-row">
            {statsItems.map(item => (
              <div className="stat-item" key={item.label}>
                <div className="stat-icon">
                  <Icon type={item.icon} />
                </div>
                <div className="stat-label">{item.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="mobile-section categories">
          <h3 className="section-title">Shop by Category</h3>
          <div className="mobile-category-scroll">
            {mobileDepartments.map((department, index) => {
              const slug = department.dep.toLowerCase().replace(/[^a-z0-9]+/g, '-');
              return (
                <Link
                  key={department.dep}
                  to={`/products?department=${encodeURIComponent(department.dep)}`}
                  className={`mobile-category-pill ${index === 0 ? "is-active" : ""}`}
                >
                  <span className={`pill-dot dep-${slug}`} aria-hidden="true" />
                  <span className="pill-label">{department.dep}</span>
                </Link>
              );
            })}
          </div>
        </section>

        <section className="mobile-section featured">
          <h3 className="section-title">Featured Products</h3>
          {featuredProducts.length ? (
            <div className="row product-cards-row-mobile">
              {featuredProducts.map((product, index) => (
                <div className="col-6 product-cards-mobile" key={product._id || index}>
                  <div className="product-card-container">
                    <ProductCard
                      data={product}
                      label={badgeLabels[index % badgeLabels.length]}
                      onSelectProduct={() => this.exploreProduct(product)}
                      onAddToCart={() => this.addToCart(product)}
                      noOutOfStock={true}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="mobile-placeholder">Loading featured products...</div>
          )}
        </section>

        <section className="mobile-section why-choose">
          <h3 className="section-title">Why Choose Jason's</h3>
          <div className="why-list">
            {benefits.map(benefit => (
              <div className="why-item" key={benefit.title}>
                <div className="why-icon">{benefit.icon}</div>
                <div className="why-title">{benefit.title}</div>
                <div className="why-subtitle">{benefit.subtitle}</div>
              </div>
            ))}
          </div>
        </section>
      </div>
    );

    const categoriesSection = (
      <section className="categories-section">
        <div className="container">
          <div className="section-header">
            <p className="eyebrow">Shop by Category</p>
          </div>
          {this.renderCategoryPills()}
        </div>
      </section>
    );

    const featuredSection = (
      <section className="featured-products-section">
        <div className="container">
          <div className="section-header">
            <p className="eyebrow">Featured Products</p>
            {/* <Link to="/products" className="text-link">View full catalog</Link> */}
          </div>
          <div className="row featured-grid">
            {featuredProducts.length ? (
              featuredProducts.map(product => (
                <div className="col-md-3 col-sm-6" key={product._id}>
                  <ProductCard
                    data={product}
                    label="Featured"
                    onSelectProduct={() => this.exploreProduct(product)}
                    onAddToCart={() => this.addToCart(product)}
                    noOutOfStock={true}
                  />
                </div>
              ))
            ) : (
              <div className="col-12 text-center">Loading featured products...</div>
            )}
          </div>
        </div>
      </section>
    );
    return (
      <div className={`page homepage ${isMobile ? "home-mobile" : ""}`}>
        {isMobile ? (
          mobileContent
        ) : (
          <React.Fragment>
            {heroSection}
            {categoriesSection}
            {featuredSection}
            <section className="visit-us">
              <div className="visit-us-inner">
                <h2 className="visit-us-title">Visit Us</h2>

                <div className="visit-us-grid">
                  <article className="visit-card">
                    <div className="visit-card-header">
                      <div className="visit-card-icon visit-card-icon--contact">
                        <span>📞</span>
                      </div>
                      <div>
                        <h3 className="visit-card-title">Contact Us</h3>
                        <p className="visit-card-subtitle">We’re here to help</p>
                      </div>
                    </div>

                    <div className="visit-card-body">
                      <a href="tel:2134859463" className="visit-contact-cta">
                        <div className="visit-contact-cta-icon">📱</div>
                        <div className="visit-contact-cta-text">
                          <span className="visit-contact-cta-label">Call Now</span>
                          <span className="visit-contact-cta-value">(213) 485-9463</span>
                        </div>
                      </a>

                      <div className="visit-contact-email">
                        <span className="visit-contact-email-label">Email</span>
                        <a href="mailto:info@jasonsliquor.com" className="visit-contact-email-link">
                          info@jasonsliquor.com
                        </a>
                      </div>
                    </div>
                  </article>

                  <article className="visit-card">
                    <div className="visit-card-header">
                      <div className="visit-card-icon visit-card-icon--location">
                        <span>📍</span>
                      </div>
                      <div>
                        <h3 className="visit-card-title">Our Location</h3>
                        <p className="visit-card-subtitle">Jason’s Wine &amp; Spirits</p>
                      </div>
                    </div>

                    <div className="visit-card-body">
                      <p className="visit-location-text">
                        828 S. Main Street<br />
                        Los Angeles, CA 90014
                      </p>

                      <a
                        href="https://maps.google.com?q=Jason%27s+Wine+%26+Spirits+828+S+Main+St+Los+Angeles"
                        target="_blank"
                        rel="noopener"
                        className="visit-location-button"
                      >
                        <span>Get Directions</span>
                      </a>
                    </div>
                  </article>

                  <article className="visit-card visit-card--hours">
                    <div className="visit-card-header">
                      <div className="visit-card-icon visit-card-icon--hours">
                        <span>🕒</span>
                      </div>
                      <div>
                        <h3 className="visit-card-title">Hours of Operation</h3>
                        <p className="visit-card-subtitle">Every day, all year</p>
                      </div>
                    </div>

                    <div className="visit-card-body">
                      <div className="visit-hours-chip">Open Daily</div>
                      <div className="visit-hours-row featured">
                        <div className="visit-hours-day">Mon – Sun</div>
                        <div className="visit-hours-time">9am – 2am</div>
                      </div>
                      <div className="visit-hours-note">
                        <i className="fa fa-calendar-check-o" aria-hidden="true" />
                        <span>365 days a year</span>
                      </div>
                      <div className="visit-hours-note strong">
                        <i className="fa fa-motorcycle" aria-hidden="true" />
                        <span>Delivery available ALL DAY</span>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </section>

            <section className="cta-ready">
              <div className="cta-ready-inner">
                <h2 className="cta-ready-title">Ready to Order?</h2>
                <p className="cta-ready-subtitle">
                  Get your favorites delivered in 30 minutes or less!
                </p>
                <a href="/shop" className="cta-ready-button">
                  Start Shopping
                </a>
              </div>
            </section>
          </React.Fragment>
        )}
        {/* {isMobile && (
          <div className="mobile-nav-stack">
            {!openDepartmentMenu
              ? this.renderMobileDepartments()
              : this.renderMobileCategories()}
          </div>
        )} */}
        <Loader visibility={loading} />
        <SweetAlert
          customClass={"with-close"}
          showCancelButton
          cancelButtonText={"x"}
          onCancel={() => this.setState({ showAlert: false })}
          show={showAlert}
          {...swalParams}
        />
      </div>
    );
  }

  onSelectFeaturedProduct(product) {
    this.props.history.push(`/products/${product._id}`);
  }

  doAgeValidation(successCallback, errorCallback) {
    const { isAgeValid } = this.state;
    let validAge = LocalStorage.get("valid_age");
    if (validAge && validAge === "yes") {
      return this.setState({ isAgeValid: true });
    }

    let swalParams = Swal.getAgeValidationParams(
      () => {
        LocalStorage.put("valid_age", "yes");
        this.setState({
          showAlert: false,
          isAgeValid: true,
          swalParams: swalParams
        });
      },
      () => {
        swalParams.text = Swal.getAgeValidationText(
          "You must be 21 years or older to use this website."
        );
        LocalStorage.put("valid_age", "no");
        this.setState({
          showAlert: true,
          isAgeValid: false,
          swalParams: swalParams
        });
      }
    );
    this.setState({ showAlert: true, swalParams: swalParams });
  }

  handleError(response) {
    console.log("error", response);
    if (!response.status) {
      this.setState({
        showAlert: true,
        swalParams: {
          title: "Something went wrong!",
          type: "error",
          showConfirmButton: false,
          customClass: "with-close",
          showCancelButton: true,
          cancelButtonText: "x",
          onCancel: this._onCancel
        }
      });
      // setTimeout(() => this.setState({showAlert: false}), 2000);
    }
  }
  _onCancel() {
    this.setState({ showAlert: false });
  }

  addToCart(product) {
    Utils.addToCart(product)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false
          }
        });
        setTimeout(() => this.setState({ showAlert: false }), 1500);
      })
      .catch(err => {
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
        setTimeout(() => this.setState({ showAlert: false }), 2500);
      });
  } 
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 992
});

export default withSizes(mapSizesToProps)(
  connect(state => {
    return {
      newArrivals: state.getIn(["products", "newArrivals"]),
      //bestSellers: state.getIn(['products', 'bestSellers']),
      specials: state.getIn(["products", "specials"]),
      featured_WINES: state.getIn(["products", "featured_WINES"]),
      featured_LIQUOR: state.getIn(["products", "featured_LIQUOR"]),
      featured_BEER: state.getIn(["products", "featured_BEER"]),
      loading:
        state.getIn(["products", "loading"]) ||
        state.getIn(["users", "loading"]),
      departments: state.getIn(["products", "departments"]) || [],
      promoImage: state.getIn(["users", "promoImage"])
    };
  })(HomePage)
);



// WEBPACK FOOTER //
// ./src/containers/home/HomePage.js